import $ from 'jquery';
import showOnScroll, { fadeSlideUp } from '@zerofool/show-on-scroll';

let numPages = 0;
let currPage = 0;
let api = '';

$(() => {
	const $posts = $('.posts');

	if ($posts.length === 0) return;

	numPages = parseInt($posts.attr('data-pages'));
	currPage = parseInt($posts.attr('data-page'));
	api = $posts.attr('data-api');

	if (currPage >= numPages) return hideMoreBtn();

	$('.posts__load-more').on('click', loadMorePosts);

	showOnScroll('.posts__item, .posts-sidebar__inner', {...fadeSlideUp, observerOptions: {threshold: .4}});
});

const loadMorePosts = (event) => {
	event.preventDefault();

	fetch(api + `?per_page=7&page=${currPage+1}&_embed`)
		.then(res => res.json())
		.then(data => {
			currPage++;

			const posts = data.map(post => {
				const title = post.title.rendered;
				const date = new Date(post.date);
				const month = date.toLocaleString('default', {month: 'long'});
				const dateStr = `${date.getDate()} ${month} ${date.getFullYear()}`;
				const link = post.link;
				const imgSrc = post?._embedded?.['wp:featuredmedia']?.[0]?.media_details?.sizes?.medium?.source_url ?? '';
				const desc = post.excerpt.rendered;
				return `
					<div class="posts__item">
						<div class="posts__top">
							<a class="posts__thumb" href="${link}">
								<img src="${imgSrc}">
							</a>
							<div class="posts__titles">
								<div class="posts__date">${dateStr}</div>
								<div class="posts__title">${title}</div>
							</div>
						</div>
						<div class="posts__desc">${desc}</div>
						<div class="posts__more">
							<a href="${link}">Read more<img src="/wp-content/themes/bpak/static/img/split-arrow.svg" alt=""></a>
						</div>
					</div>
				`
			});

			$('.posts__items').append(posts);
			
			if (currPage >= numPages) return hideMoreBtn();
		});
}

const hideMoreBtn = () => {
	$('.posts__load-more').hide();
}